<template>
  <div>
    <div class="portfolio-items mapas row">
      <div class="col-12">
        <p v-html="$t('catalogo.descripcion')"></p>

        <div style="text-align: center">
          <a :href="geonodeUrl" class="mt-30 main-btn">
            {{ $t('catalogo.acceder_al_catalogo') }}
          </a>
        </div>
        <br>

        <div class="service-row">
          <h5 v-html="$t('catalogo.wms_titulo')"></h5>
          <p v-html="$t('catalogo.wms_descripcion')"></p>

<!--          <span class="caption mb-2 pa-2" style="color: #ff5722b0;background-color: #ffede7;font-size: 11px">{{ $t('catalogo.catalogo_desactivado') }}</span>-->

          <p>{{ $t('catalogo.direccion_servei') }}: <a :href="wmsUrl" target="_blank">{{ wmsUrl }}</a></p>
          <p>{{ $t('catalogo.descripcio_servei') }}: <a :href="wmsServiceUrl" target="_blank">GetCapabilities</a></p>

        </div>

<!--        <div class="service-row">-->
<!--          <h5 v-html="$t('catalogo.csw_titulo')"></h5>-->
<!--          <p v-html="$t('catalogo.csw_descripcion')"></p>-->

<!--&lt;!&ndash;          <span class="caption mb-2 pa-2" style="color: #ff5722b0;background-color: #ffede7;font-size: 11px">{{ $t('catalogo.catalogo_desactivado') }}</span>&ndash;&gt;-->

<!--          <p>{{ $t('catalogo.direccion_servei') }}: <a :href="cswUrl" target="_blank">{{ cswUrl }}</a></p>-->
<!--          <p>{{ $t('catalogo.descripcio_servei') }}: <a :href="cswServiceUrl" target="_blank">GetCapabilities</a></p>-->
<!--        </div>-->

        <div class="service-row">
          <h5 v-html="$t('catalogo.wfs_titulo')"></h5>
          <p v-html="$t('catalogo.wfs_descripcion')"></p>

<!--          <span class="caption mb-2 pa-2" style="color: #ff5722b0;background-color: #ffede7;font-size: 11px">{{ $t('catalogo.catalogo_desactivado') }}</span>-->

          <p>{{ $t('catalogo.direccion_servei') }}: <a :href="wfsUrl" target="_blank">{{ wfsUrl }}</a></p>
          <p>{{ $t('catalogo.descripcio_servei') }}: <a :href="wfsServiceUrl" target="_blank">GetCapabilities</a></p>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
    import {AppConfig} from "../../appConfig";

    export default {
        name: 'OgcCatalogSection',
        data() {
            return {}
        },
        computed: {
            locale() {
                return this.$i18n.locale
            },
            geonodeUrl() {
                return `${AppConfig.APP_URL}/${this.locale}/catalogo`;
            },
            wmsUrl() {
                return `${AppConfig.GEONODE_URL}/geoserver/wms`;
            },
            wmsServiceUrl() {
                return `${AppConfig.GEONODE_URL}/geoserver/wms?REQUEST=GetCapabilities`;
            },
            cswUrl() {
                return `${AppConfig.GEONODE_URL}/catalogue/csw`;
            },
            cswServiceUrl() {
                return `${AppConfig.GEONODE_URL}/catalogue/csw?Service=CSW&Request=GetCapabilities`;
            },
            wfsUrl() {
                return `${AppConfig.GEONODE_URL}/geoserver/wfs`;
            },
            wfsServiceUrl() {
                return `${AppConfig.GEONODE_URL}/geoserver/wfs?Service=WFS&Request=GetCapabilities`;
            },
        },
        async mounted() {

        },
        methods: {}
    }
</script>

<style lang="scss">
  @import "../../../sass/variables";

  .service-row {
    margin-top: 3rem;
  }
</style>